import React from 'react';
import { Box, Typography, CircularProgress, GlobalStyles } from '@mui/material';
import { DS } from '../PatientForms/designTokens';

const patientFormStyles = (
  <GlobalStyles
    styles={{
      'form label:has(> input[type="radio"]:not(.sr-only)), form label:has(> input[type="checkbox"]:not(.sr-only))':
        {
          display: 'inline-flex',
          alignItems: 'center',
          padding: '0.375rem 0.875rem',
          borderRadius: '0.5rem',
          border: '1px solid #d1d5db',
          fontSize: '0.875rem',
          cursor: 'pointer',
          transition:
            'border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease',
          backgroundColor: '#ffffff',
          color: '#242829',
          userSelect: 'none',
        },
      'form label:has(> input[type="radio"]:not(.sr-only)):hover, form label:has(> input[type="checkbox"]:not(.sr-only)):hover':
        {
          borderColor: '#0E6C68',
          color: '#0E6C68',
        },
      'form label:has(> input[type="radio"]:not(.sr-only):checked), form label:has(> input[type="checkbox"]:not(.sr-only):checked)':
        {
          backgroundColor: '#0E6C68',
          borderColor: '#0E6C68',
          color: '#ffffff',
        },
      'form label:has(> input[type="radio"]:not(.sr-only)) > input[type="radio"], form label:has(> input[type="checkbox"]:not(.sr-only)) > input[type="checkbox"]':
        {
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0,
        },
    }}
  />
);

interface FormLayoutProps {
  title: string;
  description?: string;
  loading?: boolean;
  children: React.ReactNode;
}

const FormLayout: React.FC<FormLayoutProps> = ({
  title,
  description,
  loading,
  children,
}) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#F0EDE6',
        }}
      >
        <CircularProgress sx={{ color: DS.deepTeal }} />
      </Box>
    );
  }

  return (
    <>
      {patientFormStyles}
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: { xs: '#fff', sm: '#F0EDE6' },
          py: { xs: 2, sm: 3 },
          px: { xs: 2, sm: 1.5 },
          overflowX: 'hidden',
        }}
      >
        <Box
          sx={{
            maxWidth: '672px',
            mx: 'auto',
            backgroundColor: '#fff',
            borderRadius: { xs: 0, sm: '8px' },
            p: { xs: 0, sm: 3 },
          }}
        >
          <Typography
            component="h1"
            sx={{
              fontSize: '36px',
              fontWeight: 600,
              textAlign: 'center',
              color: DS.deepTeal,
              mb: 3,
              fontFamily: DS.fontDisplay,
            }}
          >
            {title}
          </Typography>
          {description && (
            <Typography
              sx={{
                my: 2,
                fontSize: '16px',
                lineHeight: 1.6,
                fontFamily: DS.fontBody,
                color: DS.softBlack,
              }}
            >
              {description}
            </Typography>
          )}
          {children}
        </Box>
      </Box>
    </>
  );
};

export default FormLayout;
